import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ContactInfo, LoginCredentials, LoginResponse } from '@store/user/user.model';
import { Observable } from 'rxjs';
import { DirectLinkReportData } from '@store/reports/reports.model';

@Injectable({
  providedIn: 'root'
})
export class UserService {

  constructor(private readonly httpClient: HttpClient) { }

  public login(credentials: LoginCredentials): Observable<LoginResponse> {
    return this.httpClient.post<LoginResponse>('/api/login', credentials);
  }

  public directLogin(): Observable<LoginResponse> {
    return this.httpClient.get<LoginResponse>('/api/directLogin');
  }

  public logout(): Observable<void> {
    return this.httpClient.post<void>('/api/logout', null);
  }

  public getDirectLinkData(): Observable<DirectLinkReportData> {
    return this.httpClient.get<DirectLinkReportData>('/api/reports/direct-link');
  }

  public getLoginData(): Observable<LoginResponse> {
    return this.httpClient.get<LoginResponse>('/api/afterLoginGetData');
  }

  public getHelpPageContactInfo(): Observable<Array<ContactInfo>> {
    return this.httpClient.get<Array<ContactInfo>>('/api/contacts');
  }

  public keepSession(): Observable<void> {
    return this.httpClient.get<void>(`/api/refreshSession`);
  }

  public getMySearchData(): Observable<LoginResponse> {
    return this.httpClient.get<LoginResponse>(`/api/getSavedMySearches`);
  }

  public getReplyToEmailAddress(): Observable<string> {
    return this.httpClient.post(`/api/from-email`, null, { responseType: 'text' });
  }
}
